// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__60H5a","productName":"Table_productName__14Pls"};